const conversations = {
  add: "Agregar Chat",
  title: "Chats",
  button: "Agregar",
  saved: "Chat guardado",
  deleted: "Chat eliminado",
  upload_new_file: "Cargar nuevo archivo",
  files: "Archivos",
  conversation_files: "Archivos del Chat",
  search: "Buscar en los chats...",
  empty: "No tienes ningún chat.",
  empty_files: "No se encontraron archivos en este chat.",
  spinner: "Espera un momento, estamos en tus respuestas",
};

export default conversations;
